// extracted by mini-css-extract-plugin
export default {"about_header":"about_about_header__I91uL","imgWrapper":"about_imgWrapper__bQXCq","about_footer":"about_about_footer__8bbwF","about_content":"about_about_content__caCcK"};